var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBaremetal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15.5,
    fill: "white",
    stroke: "#E0E0E0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_963_63641)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 11.5C12.7761 11.5 13 11.2761 13 11C13 10.7239 12.7761 10.5 12.5 10.5C12.2239 10.5 12 10.7239 12 11C12 11.2761 12.2239 11.5 12.5 11.5Z",
    fill: "#0043CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 13H11C10.7349 12.9997 10.4807 12.8943 10.2932 12.7068C10.1057 12.5193 10.0003 12.2651 10 12V10C10.0003 9.73487 10.1057 9.48068 10.2932 9.2932C10.4807 9.10572 10.7349 9.00028 11 9H21C21.2651 9.00028 21.5193 9.10572 21.7068 9.2932C21.8943 9.48068 21.9997 9.73487 22 10V12C21.9997 12.2651 21.8943 12.5193 21.7068 12.7068C21.5193 12.8943 21.2651 12.9997 21 13ZM11 10V12H21V10H11Z",
    fill: "#0043CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 16.5C12.7761 16.5 13 16.2761 13 16C13 15.7239 12.7761 15.5 12.5 15.5C12.2239 15.5 12 15.7239 12 16C12 16.2761 12.2239 16.5 12.5 16.5Z",
    fill: "#0043CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 18H11C10.7349 17.9997 10.4807 17.8943 10.2932 17.7068C10.1057 17.5193 10.0003 17.2651 10 17V15C10.0003 14.7349 10.1057 14.4807 10.2932 14.2932C10.4807 14.1057 10.7349 14.0003 11 14H21C21.2651 14.0003 21.5193 14.1057 21.7068 14.2932C21.8943 14.4807 21.9997 14.7349 22 15V17C21.9997 17.2651 21.8943 17.5193 21.7068 17.7068C21.5193 17.8943 21.2651 17.9997 21 18ZM11 15V17H21V15H11Z",
    fill: "#0043CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 21.5C12.7761 21.5 13 21.2761 13 21C13 20.7239 12.7761 20.5 12.5 20.5C12.2239 20.5 12 20.7239 12 21C12 21.2761 12.2239 21.5 12.5 21.5Z",
    fill: "#0043CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 23H11C10.7349 22.9997 10.4807 22.8943 10.2932 22.7068C10.1057 22.5193 10.0003 22.2651 10 22V20C10.0003 19.7349 10.1057 19.4807 10.2932 19.2932C10.4807 19.1057 10.7349 19.0003 11 19H21C21.2651 19.0003 21.5193 19.1057 21.7068 19.2932C21.8943 19.4807 21.9997 19.7349 22 20V22C21.9997 22.2651 21.8943 22.5193 21.7068 22.7068C21.5193 22.8943 21.2651 22.9997 21 23ZM11 20V22H21V20H11Z",
    fill: "#0043CE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_963_63641"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaremetal);
export default __webpack_public_path__ + "static/media/baremetal.582e45eff36baad4dba402670fa4a014.svg";
export { ForwardRef as ReactComponent };